type ConfigType = {
  [key: string]: string;
};

const envVariables = process.env;

const Config: ConfigType = {};

Object.keys(envVariables).forEach((variable) => {
  const envTestRegex = /^(NX_)|(REACT_APP_)|(FIREBASE_)|(GOOGLE_)|(GATSBY_)/;
  if (envTestRegex.test(variable)) {
    const envKey = variable.replace(envTestRegex, '');
    const envValue = envVariables[variable];
    if (envValue !== undefined) {
      Config[envKey] = envValue;
    }
  }
});

export { Config };
